<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Kode kegiatan" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Kode"
                    label="Kode"
                    dense
                    :error-messages="errors"
                    placeholder="Kode kegiatan"
                    v-model="form.Kode"
                    hide-details="auto"
                    outlined
                    required
                  ></v-text-field>
                </Validate>
                <Validate name="Nama kegiatan" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Nama"
                    dense
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama kegiatan"
                    v-model="form.Nama"
                    hide-details="auto"
                    outlined
                    required
                  ></v-text-field>
                </Validate>
                <Validate name="Program" rules="required" #default="{ errors }">
                  <v-autocomplete
                    class="mb-3"
                    :items="list.program.data"
                    item-text="Nama"
                    item-value="IDProgram"
                    name="Program"
                    label="Program"
                    :error-messages="errors"
                    placeholder="Nama Program"
                    v-model="form.IDProgram"
                    :return-object="false"
                    hide-details="auto"
                    outlined
                    dense
                  >
                    <template v-slot:selection="data">
                      {{data.item.Nama}}
                      &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Kode}}</span>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title class="py-0">
                            {{data.item.Nama}}
                            &mdash;
                            <span
                              class="text--secondary"
                            >{{data.item.Kode}}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </Validate>
                <Validate name="Urusan" rules="required" #default="{ errors }">
                  <v-autocomplete
                    class="mb-3"
                    :items="list.urusan.data"
                    item-text="Nama"
                    item-value="IDUrusan"
                    name="Urusan"
                    label="Urusan"
                    :error-messages="errors"
                    placeholder="Nama Urusan"
                    v-model="form.IDUrusan"
                    :return-object="false"
                    outlined
                    hide-details="auto"
                    dense
                  >
                    <template v-slot:selection="data">
                      {{data.item.Nama}}
                      &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Kode}}</span>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title class="py-0">
                            {{data.item.Nama}}
                            &mdash;
                            <span
                              class="text--secondary"
                            >{{data.item.Kode}}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </Validate>
                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Kode: "",
      Nama: "",
      IDProgram: "",
      IDUrusan: ""
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isProgramLoading", "isUrusanLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/administration/kegiatan", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/kegiatan");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Kegiatan" : "Kegiatan Baru";
    },

    ...mapActions("list", ["refreshProgram", "refreshUrusan"])
  },
  async mounted() {
    this.refreshProgram();
    this.refreshUrusan();
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/administration/kegiatan/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  },
  watch: {
    "form.IDProgram"(v) {
      let listProgram = this.list.program.data || [];
      let program = listProgram.find(x => x.IDProgram == v);
      if (program) {
        this.form.IDBidang = program.IDBidang;
      }
    }
  }
};
</script>

<style>
</style>